<template>
    <div>
        <k-wms-leaflet-map
            :center="center"
            :markers="markers"
            :polygons="parsedPolygons"
            :fullscreen="fullscreen"
            :height="height"
            :zoom="zoom"
            :minZoom="minZoom"
            :maxZoom="maxZoom"
            :gursSessionId="gursSessionId"
            :extraLayers="extraLayers"
            :legend="legend"
            ref="map"
        >
            <template v-slot:popup_content_marker v-if="popupContent">
                <p>{{popupContent}}</p>
            </template>

            <template v-slot:popup_content_polygon v-if="popupContent">
                <p>{{popupContent}}</p>
            </template>

            <template v-for="(index, name) in $slots" v-slot:[name]>
                <slot :name="name" />
            </template>
            <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
                <slot :name="name" v-bind="data"></slot>
            </template>
        </k-wms-leaflet-map>
    </div>
</template>

<script>
import KWMSLeafletMap from "@/components/k-leaflet-map/KWMSLeafletMap";
import commonprops from "./commonprops";

export default {
    components: {
        "k-wms-leaflet-map": KWMSLeafletMap,
    },
    props: {
        ...commonprops,
        extraLayers: {
            type: Array
        },
        legend: {
            type: Object
        },
        minZoom: {
            type: Number
        },
        maxZoom: {
            type: Number,
            default: 19
        },
    },
    computed: {
        center: function(){
            return {
                lat: this.lat,
                lng: this.lng
            }
        },
        markers: function(){
            return [{
                coordinates: this.center
            }]
        },
        parsedPolygons: function(){
            if (!this.polygons) {
                return [];
            }
            // If polygons is already an array, return it
            if (Array.isArray(this.polygons)) {
                return this.polygons;
            }
            // If polygons is a string, try to parse it
            if (typeof this.polygons === "string") {
                try {
                    const parsed = JSON.parse(this.polygons);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    console.warn("Failed to parse polygons:", e);
                    return [];
                }
            }
            return [];
        },
        leafletMapObject: function(){
            return this.$refs.map ? this.$refs.map.leafletMapObject : null;
        }
    },
}
</script>

<style>
    @import "~leaflet/dist/leaflet.css";
    @import "~leaflet-fullscreen/dist/leaflet.fullscreen.css";
</style>